import {Dimensions, Platform} from 'react-native';
import Modal from 'react-native-modal';
import Feather from 'react-native-vector-icons/Feather';
import FastImage from 'react-native-fast-image';

import {
  getBottomSpace,
  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;
export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${getStatusBarHeight()}PX;
  right: 24px;
`;
export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(18)}px;
`;
export const ContainerImage = styled.View`
  z-index: 1;
`;
const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 431
    ? RFValue(190)
    : RFValue(208)
  : RFValue(195);
export const VehicleBanner = styled(FastImage)`
  width: 100%;
  height: ${imageDimensions}px;
  position: absolute;
  bottom: -${RFValue(30)}px;
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  height: ${RFPercentage(60)}px;

  overflow: hidden;
`;
export const ModalBody = styled.ScrollView`
  margin-top: ${RFValue(40)}px;
  max-height: 100%;
  padding: 0 24px;
`;
export const ReferAndWinContainer = styled.View``;
export const CodeArea = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: ${RFValue(40)}px;
  margin-bottom: ${RFValue(12)}px;

  border-style: dashed;
  border-color: ${({theme}) => theme.colors.border};
  border-width: 2px;
  border-radius: ${RFValue(12)}px;
  padding: 0 24px;
`;
export const Code = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
`;
export const CopyCodeButton = styled.TouchableOpacity``;
export const CopyCodeIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(14)}px;
`;
export const CheckRateTextBold = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;
export const List = styled.View`
  flex: 1;
`;
export const VehicleTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;
export const VehicleText = styled.Text`
  color: ${({theme}) => theme.colors.placeholder};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-bottom: ${RFValue(12)}px;
`;
export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
